export const PHONE = 'AIRCALL-PHONE';
export const AIRCALL = 'AIRCALL-CLIENT';
export const VISIBLE = 'AIRCALL-VISIBLE';
